"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _ReplicationConfiguration_1 = require("./_ReplicationConfiguration");
exports.PutBucketReplicationInput = {
    type: "structure",
    required: ["Bucket", "ReplicationConfiguration"],
    members: {
        Bucket: {
            shape: {
                type: "string"
            },
            location: "uri",
            locationName: "Bucket"
        },
        ContentMD5: {
            shape: {
                type: "string"
            },
            location: "header",
            locationName: "Content-MD5"
        },
        ReplicationConfiguration: {
            shape: _ReplicationConfiguration_1._ReplicationConfiguration,
            locationName: "ReplicationConfiguration",
            xmlNamespace: {
                uri: "http://s3.amazonaws.com/doc/2006-03-01/"
            }
        }
    },
    payload: "ReplicationConfiguration"
};
//# sourceMappingURL=PutBucketReplicationInput.js.map